import React, { useEffect } from 'react';
import { Survey } from '../../../../../common/src/domain/survey/survey/surveyTableSchema';
import { useTranslate } from '../../../mixins/translate/translate';
import { openApiFetchGet, openApiFetchPost } from '../../../store/openApiFetch';
import { EditPanelButton, EditPanelButtons, EditPanelCell, EditPanelDatePicker, EditPanelInput, EditPanelRow, PanelBody } from '../../elements';
import { showSavedToast } from '../../utils/toastMessages';
import { SurveyEditCollapsiblePanel } from './SurveyEditCollapsiblePanel';

export function SurveyEditWorkflowSettingsBody(props: { surveyId: string }) {
    const { surveyId } = props;
    const translate = useTranslate();
    const [surveyState, setSurveyState] = React.useState<Pick<Survey, 'reportDeadlineOnDate' | 'linkToDocuments'>>({
        linkToDocuments: null,
        reportDeadlineOnDate: null,
    });

    useEffect(() => {
        async function loadSurvey() {
            const survey = await openApiFetchGet('/api/surveys/{surveyId}', { surveyId });
            setSurveyState(survey);
        }
        void loadSurvey();
    }, [surveyId]);

    async function save() {
        await openApiFetchPost(
            '/api/surveys/{surveyId}',
            { surveyId },
            { reportDeadlineOnDate: surveyState.reportDeadlineOnDate ?? null, linkToDocuments: surveyState.linkToDocuments ?? null },
        );
        showSavedToast(translate);
    }

    if (!surveyState) {
        return null;
    }

    return (
        <PanelBody isForm={true}>
            <EditPanelRow>
                <EditPanelCell rowCount={2}>
                    <EditPanelDatePicker
                        name="reportDeadlineOnDate"
                        value={surveyState.reportDeadlineOnDate}
                        handleChange={(value) => setSurveyState((i) => ({ ...i, reportDeadlineOnDate: value }))}
                        topLabel={translate('survey.reportDeadlineOnDate')}
                    />
                </EditPanelCell>
            </EditPanelRow>
            <EditPanelRow>
                <EditPanelCell rowCount={10}>
                    <EditPanelInput
                        name="linkToDocuments"
                        value={surveyState.linkToDocuments}
                        handleChange={(value) => setSurveyState((i) => ({ ...i, linkToDocuments: value }))}
                        topLabel={translate('workflow.linkToDocuments')}
                    />
                </EditPanelCell>
            </EditPanelRow>
            <EditPanelButtons>
                <EditPanelButton primary text={translate('common.save')} onClick={save} iconClass="fa fa-save" small />
            </EditPanelButtons>
        </PanelBody>
    );
}

export function SurveyEditWorkflowSettings(props: { surveyId: string }) {
    const { surveyId } = props;
    const translate = useTranslate();

    return (
        <SurveyEditCollapsiblePanel initialIsClosed={true} headerText={translate('common.settings')}>
            <SurveyEditWorkflowSettingsBody surveyId={surveyId} />
        </SurveyEditCollapsiblePanel>
    );
}
